import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { trackLead } from '../utils/analytics';
const faqs = [{
  question: 'Jsou rady skutečně 100% ZDARMA?',
  answer: 'Ano, veškeré rady a tipy v tomto videu jsou zcela zdarma. Mým cílem je pomoci co nejvíce začátečníkům vyhnout se chybám, které jsem dělal já.'
}];
export const RadyPage: React.FC = () => {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleCtaClick = () => {
    trackLead('Free Tips Rady', 'free_rady');
    window.location.href = 'https://buy.stripe.com/fZu3cucIH7LY6wt2vAg7e03';
  };
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-green-500/30" data-id="element-1903">
      {/* Header */}
      <header className="py-6 text-center border-b border-gray-800/50" data-id="element-1904"></header>

      <main className="max-w-2xl mx-auto px-4 py-8 md:py-12" data-id="element-1905">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-1906">
          {/* Hero Image */}
          <div className="relative rounded-2xl overflow-hidden mb-8 shadow-2xl shadow-black/50 ring-1 ring-white/10" data-id="element-1907">
            <img src="https://cdn.magicpatterns.com/uploads/gADNuGzfanmLPdspUdb2ZU/openart-image_97OQdk2p_1773075169549_raw_(2).jpg" alt="Transformace – před a potom" className="w-full h-auto object-cover" data-id="element-1908" />

            {/* Badges */}
          </div>

          {/* Copy */}
          <div className="space-y-6 mb-10" data-id="element-1909">
            <h1 className="text-2xl md:text-3xl font-bold leading-tight text-white" data-id="element-1910">
              🚀 Rady, které mi pomohly dosáhnout vysněné postavy a jak z
              úplného{' '}
              <span style={{
              fontFamily: "'Playfair Display', serif"
            }} className="text-green-500 italic" data-id="element-1911">
                začátečníka
              </span>{' '}
              jsem nabral 23 kg svalů 🔥
            </h1>

            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-1912">
              V následujícím videu získáš{' '}
              <strong className="text-white" data-id="element-1913">znalosti</strong>, díky kterým
              budeš vědět víc než{' '}
              <strong className="text-white" data-id="element-1914">95 % začátečníků</strong> v
              posilovně. Díky tomu{' '}
              <strong className="text-white" data-id="element-1915">výrazně zvýšíš svou šanci</strong>{' '}
              dosáhnout vysněné postavy a už během{' '}
              <strong className="text-white" data-id="element-1916">90 dní</strong> můžeš být{' '}
              <strong className="text-white" data-id="element-1917">
                mnohem blíž tělu, o kterém jsi vždycky snil
              </strong>
              .
            </p>

            <div className="flex items-start gap-2 text-base md:text-lg text-gray-300" data-id="element-1918">
              <span className="flex-shrink-0" data-id="element-1919">✅</span>
              <span data-id="element-1920">
                Bez nutnosti{' '}
                <strong className="text-white" data-id="element-1921">extrémních diet</strong> a{' '}
                <strong className="text-white" data-id="element-1922">
                  extrémně dlouhých tréninků v posilovně
                </strong>
                .
              </span>
            </div>

            {/* Client results heading */}
            <h2 className="text-2xl md:text-3xl font-bold leading-tight text-white pt-4" data-id="element-1923">
              Jak tyto{' '}
              <span style={{
              fontFamily: "'Playfair Display', serif"
            }} className="text-green-500 italic" data-id="element-1924">
                stejné rady
              </span>{' '}
              pomohly i mým klientům dosáhnout jejich vysněné postavy🔥
            </h2>

            {/* Client transformation photos */}
            <div className="space-y-4" data-id="element-1925">
              {/* Client 1 */}
              <div className="relative rounded-xl overflow-hidden ring-1 ring-white/10 shadow-lg" data-id="element-1926">
                <div className="grid grid-cols-2 gap-0" data-id="element-1927">
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1928">
                    <img src="https://cdn.magicpatterns.com/uploads/3aukJj5dQN8w5xwdnQ2pkG/Screenshot_2026-03-09_at_19.55.07.png" alt="Klient před" className="w-full h-full object-cover object-center" data-id="element-1929" />
                    <div className="absolute bottom-2 left-2 bg-red-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1930">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1931">
                        PŘED
                      </span>
                    </div>
                  </div>
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1932">
                    <img src="https://cdn.magicpatterns.com/uploads/3wwHV1mHRu4YoWB92ofmE6/Screenshot_2025-12-27_at_20.25.37.png" alt="Klient po" className="w-full h-full object-cover object-center" data-id="element-1933" />
                    <div className="absolute bottom-2 right-2 bg-green-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1934">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1935">
                        PO
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Client 2 */}
              <div className="relative rounded-xl overflow-hidden ring-1 ring-white/10 shadow-lg" data-id="element-1936">
                <div className="grid grid-cols-2 gap-0" data-id="element-1937">
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1938">
                    <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_UfvYMToM_864x1152_1766861258705.webp" alt="Klient před" className="w-full h-full object-cover object-[center_35%]" data-id="element-1939" />
                    <div className="absolute bottom-2 left-2 bg-red-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1940">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1941">
                        PŘED
                      </span>
                    </div>
                  </div>
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1942">
                    <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_UgQvynrt_800x1264_1766948855818.webp" alt="Klient po" className="w-full h-full object-cover object-center" data-id="element-1943" />
                    <div className="absolute bottom-2 right-2 bg-green-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1944">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1945">
                        PO
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Client 3 */}
              <div className="relative rounded-xl overflow-hidden ring-1 ring-white/10 shadow-lg" data-id="element-1946">
                <div className="grid grid-cols-2 gap-0" data-id="element-1947">
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1948">
                    <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_7A0OcnL3_800x1248_1766860727661.webp" alt="Klient před" className="w-full h-full object-cover object-[center_20%]" data-id="element-1949" />
                    <div className="absolute bottom-2 left-2 bg-red-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1950">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1951">
                        PŘED
                      </span>
                    </div>
                  </div>
                  <div className="relative h-[200px] md:h-[300px] overflow-hidden" data-id="element-1952">
                    <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_h8HK1UaO_976x1024_1766861040822.webp" alt="Klient po" className="w-full h-full object-cover object-center" data-id="element-1953" />
                    <div className="absolute bottom-2 right-2 bg-green-600/80 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-1954">
                      <span className="text-white font-bold text-[10px] md:text-sm" data-id="element-1955">
                        PO
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="mb-16" data-id="element-1956">
            <button onClick={handleCtaClick} className="w-full bg-green-500 hover:bg-green-400 text-black font-black text-lg py-4 rounded-xl transition-all duration-300 shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.5)] active:scale-[0.98]" data-id="element-1957">
              CHCI RADY ZDARMA!
            </button>
            <div className="mt-4 flex items-center justify-center gap-2" data-id="element-1958">
              <div className="flex -space-x-1.5" data-id="element-1959">
                {[...Array(5)].map((_, i) => <div key={i} className="w-5 h-5 rounded-full bg-gradient-to-br from-green-400 to-green-600 border-2 border-[#0a0a0a] flex items-center justify-center" data-id="element-1960">
                    <span className="text-[8px] text-white" data-id="element-1961">✓</span>
                  </div>)}
              </div>
              <p className="text-sm md:text-base text-gray-400 italic" data-id="element-1962">
                Už{' '}
                <span className="text-green-500 font-bold not-italic" data-id="element-1963">
                  1 000+
                </span>{' '}
                lidí si nechalo poslat rady zdarma!
              </p>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="mb-16" data-id="element-1964">
            <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center text-white" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-1965">
              <span className="text-green-500 italic" data-id="element-1966">
                Frequently Asked Questions
              </span>
            </h2>
            <div className="space-y-4" data-id="element-1967">
              {faqs.map((faq, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} viewport={{
              once: true
            }} className="bg-gray-900/60 backdrop-blur-sm rounded-xl border border-green-500/30 overflow-hidden hover:border-green-500/50 transition-all duration-300" data-id="element-1968">
                  <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors duration-300" data-id="element-1969">
                    <span className="text-base md:text-lg font-medium text-white pr-4" data-id="element-1970">
                      {faq.question}
                    </span>
                    <div className="flex-shrink-0" data-id="element-1971">
                      {openFaq === index ? <MinusIcon className="w-6 h-6 text-green-500" data-id="element-1972" /> : <PlusIcon className="w-6 h-6 text-green-500" data-id="element-1973" />}
                    </div>
                  </button>
                  <AnimatePresence data-id="element-1974">
                    {openFaq === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-1975">
                        <div className="px-6 pb-5 pt-1" data-id="element-1976">
                          <div className="text-sm md:text-base text-gray-300 leading-relaxed whitespace-pre-line" data-id="element-1977">
                            {faq.answer}
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>)}
            </div>
          </div>

          {/* Footer Link */}
          <div className="text-center pb-8" data-id="element-1978">
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 underline transition-colors" data-id="element-1979">
              Privacy Policy
            </a>
          </div>
        </motion.div>
      </main>
    </div>;
};